import { useState } from "react";
import Input from "../../../common/Input";
import Button from "../../../common/Button";
import DropDown from "../../../common/icons/DropDown";
import { useDispatch } from "react-redux";
import {
  fetchStoreById,
  modifyStore,
} from "../../../../redux/Thunk/Store/StoreThunks";
import toast from "react-hot-toast";

const BillingSettings = ({
  handleCheckboxChange,
  storeById,
  handleChange,
  values,
  setFieldValue,
  initialValues,
}) => {
  const [showBillingDetails, setShowBillingDetails] = useState(false);
  // const { handleChange, values } = formik;
  const dispatch = useDispatch();

  const handleBlur = async (e, fieldPath, label) => {
    const storeId = values?.storeDetails?.SID;
    const currentValue = values?.billing[fieldPath]?.[label];
    const initialValue = storeById?.storeBillingDetail
      ? storeById?.storeBillingDetail[fieldPath]?.[label]
      : "";

    if (JSON.stringify(currentValue) === JSON.stringify(initialValue)) {
      return;
    }

    let updatedData;

    updatedData = {
      billing: {
        ...values.billing,
        [fieldPath]: {
          ...values?.billing[fieldPath],
        },
      },
    };
    const response = await dispatch(
      modifyStore({ storeId, updatedData })
    ).unwrap();

    if (response?.status === 200) {
      toast.success("Charges successfully updated.");
      dispatch(fetchStoreById({ storeId: values?.storeDetails?.SID }));
      // setSelectedStore("");
      // formik.resetForm({
      //   values: formik?.initialValues,
      // });
    } else {
      // Handle failure if needed
    }
  };

  return (
    <div className="bg-gray-100 py-3 px-5 rounded-[12px]">
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setShowBillingDetails(!showBillingDetails)}
      >
        <h3 className="text-[16px] font-medium text-secondry-600">
          Billing Settings
        </h3>
        <DropDown />
      </div>
      {showBillingDetails && (
        <div className="pt-3">
          <div className="relative mb-4">
            {/* <label className="cus-checkbox flex"> */}
            <Button
              onClick={(e) => {
                handleCheckboxChange(e, "applyAll", setFieldValue, values);
              }}
              className="bg-primary-600 h-[36px] text-white py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
              type="button"
            >
              Apply To All Stores{" "}
            </Button>
            {/* <input
                type="checkbox"
                checked={values?.billing?.applyAll}
                onChange={(e) => {
                  formik.setFieldValue("billing.applyAll", e?.target?.checked);

                  handleCheckboxChange(e);
                }}
                className="cursor-pointer w-auto"
              /> */}
            {/* <span></span>
              <p
                className="w-[calc(100%_-_24px)] pl-3 text-[16px] text-black-lose cursor-pointer"
                onClick={(e) => e.preventDefault()}
              >
                Apply To All Stores
              </p> */}
            {/* </label> */}
          </div>
          <div className="grid grid-cols-12 gap-[8px] items-center">
            <div className="col-span-4">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={values?.billing?.smallCartFee?.enable}
                  onChange={(e) => {
                    handleCheckboxChange(
                      e,
                      "smallCartFee",
                      setFieldValue,
                      values
                    );
                  }}
                  className="sr-only peer"
                />
                <div className="relative w-7 h-4 bg-primary-500 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:bg-success-600"></div>
                <span
                  className="ms-3 text-sm font-medium text-black-lose"
                  onClick={(e) => e?.preventDefault()}
                >
                  Small Cart Fee
                </span>
              </label>
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Charges"
                name="billing.smallCartFee.charges"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.smallCartFee?.charges}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) => handleBlur(e, "smallCartFee", "charges")}
              />
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Apply Below"
                name="billing.smallCartFee.applyBelow"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.smallCartFee?.applyBelow}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) => handleBlur(e, "smallCartFee", "applyBelow")}
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-[8px] items-center">
            <div className="col-span-4">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={values?.billing?.handlingFee?.enable}
                  onChange={(e) => {
                    setFieldValue(
                      "billing.handlingFee.enable",
                      e.target.checked
                    );
                    handleCheckboxChange(
                      e,
                      "handlingFee",
                      setFieldValue,
                      values
                    );
                  }}
                  className="sr-only peer"
                />
                <div className="relative w-7 h-4 bg-primary-500 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:bg-success-600"></div>
                <span
                  className="ms-3 text-sm font-medium text-black-lose"
                  onClick={(e) => e.preventDefault()}
                >
                  Handling Fee
                </span>
              </label>
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Charges"
                name="billing.handlingFee.charges"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.handlingFee?.charges}
                onChange={(e) => {
                  let value = e?.target?.value?.trim();
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, "");
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) => handleBlur(e, "handlingFee", "charges")}
              />
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Apply Below"
                name="billing.handlingFee.applyBelow"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.handlingFee?.applyBelow}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) => handleBlur(e, "handlingFee", "applyBelow")}
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-[8px] items-center">
            <div className="col-span-4">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={values?.billing?.deliveryChargesSameCity?.enable}
                  onChange={(e) => {
                    setFieldValue(
                      "billing.deliveryChargesSameCity.enable",
                      e.target.checked
                    );
                    handleCheckboxChange(
                      e,
                      "deliveryChargesSameCity",
                      setFieldValue,
                      values
                    );
                  }}
                  className="sr-only peer"
                />
                <div className="relative w-7 h-4 bg-primary-500 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:bg-success-600"></div>
                <span
                  className="ms-3 text-sm font-medium text-black-lose"
                  onClick={(e) => e.preventDefault()}
                >
                  Delivery Charges (Same City)
                  <span
                    className="text-primary-400 text-[13px] block"
                    onClick={(e) => e.preventDefault()}
                  >
                    *only on Address delivery orders
                  </span>
                </span>
              </label>
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Charges"
                name="billing.deliveryChargesSameCity.charges"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.deliveryChargesSameCity?.charges}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) =>
                  handleBlur(e, "deliveryChargesSameCity", "charges")
                }
              />
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Apply Below"
                name="billing.deliveryChargesSameCity.applyBelow"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.deliveryChargesSameCity?.applyBelow}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) =>
                  handleBlur(e, "deliveryChargesSameCity", "applyBelow")
                }
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-[8px] items-center">
            <div className="col-span-4">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={values?.billing?.deliveryChargesSameState?.enable}
                  onChange={(e) => {
                    setFieldValue(
                      "billing.deliveryChargesSameState.enable",
                      e.target.checked
                    );
                    handleCheckboxChange(
                      e,
                      "deliveryChargesSameState",
                      setFieldValue,
                      values
                    );
                  }}
                  className="sr-only peer"
                />
                <div className="relative w-7 h-4 bg-primary-500 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:bg-success-600"></div>
                <span
                  className="ms-3 text-sm font-medium text-black-lose"
                  onClick={(e) => e.preventDefault()}
                >
                  Delivery Charges (Same State)
                  <span
                    className="text-primary-400 text-[13px] block"
                    onClick={(e) => e.preventDefault()}
                  >
                    *only on Address delivery orders
                  </span>
                </span>
              </label>
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Charges"
                name="billing.deliveryChargesSameState.charges"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.deliveryChargesSameState?.charges}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) =>
                  handleBlur(e, "deliveryChargesSameState", "charges")
                }
              />
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Apply Below"
                name="billing.deliveryChargesSameState.applyBelow"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.deliveryChargesSameState?.applyBelow}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) =>
                  handleBlur(e, "deliveryChargesSameState", "applyBelow")
                }
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-[8px] items-center">
            <div className="col-span-4">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={values?.billing?.deliveryChargesOtherState?.enable}
                  onChange={(e) => {
                    setFieldValue(
                      "billing.deliveryChargesOtherState.enable",
                      e.target.checked
                    );
                    handleCheckboxChange(
                      e,
                      "deliveryChargesOtherState",
                      setFieldValue,
                      values
                    );
                  }}
                  className="sr-only peer"
                />
                <div className="relative w-7 h-4 bg-primary-500 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:bg-success-600"></div>
                <span
                  className="ms-3 text-sm font-medium text-black-lose"
                  onClick={(e) => e.preventDefault()}
                >
                  Delivery Charges (Other State)
                  <span
                    className="text-primary-400 text-[13px] block"
                    onClick={(e) => e.preventDefault()}
                  >
                    *only on Address delivery orders
                  </span>
                </span>
              </label>
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Charges"
                name="billing.deliveryChargesOtherState.charges"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.deliveryChargesOtherState?.charges}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) =>
                  handleBlur(e, "deliveryChargesOtherState", "charges")
                }
              />
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Apply Below"
                name="billing.deliveryChargesOtherState.applyBelow"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.deliveryChargesOtherState?.applyBelow}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) =>
                  handleBlur(e, "deliveryChargesOtherState", "applyBelow")
                }
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-[8px] items-center">
            <div className="col-span-4">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={values?.billing?.noDiscount?.enable}
                  onChange={(e) => {
                    handleCheckboxChange(
                      e,
                      "noDiscount",
                      setFieldValue,
                      values
                    );
                  }}
                  className="sr-only peer"
                />
                <div className="relative w-7 h-4 bg-primary-500 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:bg-success-600"></div>
                <span
                  className="ms-3 text-sm font-medium text-black-lose"
                  onClick={(e) => e.preventDefault()}
                >
                  No Discount
                </span>
              </label>
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Percentage"
                name="billing.noDiscount.percentage"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.noDiscount?.percentage}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) => handleBlur(e, "noDiscount", "percentage")}
              />
            </div>
            <div className="col-span-4 mb-3">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Apply Below"
                name="billing.noDiscount.applyBelow"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                value={values?.billing?.noDiscount?.applyBelow}
                onChange={(e) => {
                  let value = e?.target?.value?.trim(); // Trim whitespace
                  if (!isNaN(value)) {
                    value = value?.replace(/^0+(?=\d)/, ""); // Remove leading zeros
                  }
                  handleChange({
                    target: {
                      name: e.target.name,
                      value,
                    },
                  });
                }}
                onBlur={(e) => handleBlur(e, "noDiscount", "applyBelow")}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BillingSettings;
